import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, lifecycle, renderComponent, branch, renderNothing } from 'recompose';
import { Table } from 'react-bootstrap';


import allMissingTicketNumbers from '../graphql/allMissingTicketNumbers';
import { getSelectedMissingTicketNumberId } from '../selectors';
import { selectMissingTicketNumberId as selectMissingTicketNumberIdAction } from '../actions';


const propTypes = exact({
  /* eslint-disable react/no-unused-prop-types */
  only_not_expected: PropTypes.bool.isRequired,
  /* eslint-enable react/no-unused-prop-types */

  missingTicketNumbers: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedMissingTicketNumberId: PropTypes.string.isRequired,
  selectMissingTicketNumberId: PropTypes.func.isRequired,
});


const MissingTicketNumbersList = (props) => {
  const { selectedMissingTicketNumberId, selectMissingTicketNumberId } = props;

  const renderMissingTicketNumberRow = (missingTicketNumber) => {
    const {
      id,
      previousNumber,
      nextNumber,
      totalMissing,
    } = missingTicketNumber;

    const handleClick = () => { selectMissingTicketNumberId(id); };
    const isActive = selectedMissingTicketNumberId === id;

    return (
      <tr key={id} onClick={handleClick} className={isActive ? 'active' : ''}>
        <td>{previousNumber}</td>
        <td>{nextNumber}</td>
        <td>{totalMissing}</td>
      </tr>
    );
  };

  const { missingTicketNumbers } = props;

  return (
    <Table>
      <thead>
        <tr>
          <th>Previous</th>
          <th>Next</th>
          <th>Total Missing</th>
        </tr>
      </thead>
      <tbody>
        { missingTicketNumbers.map(renderMissingTicketNumberRow, this) }
      </tbody>
    </Table>
  );
};


MissingTicketNumbersList.propTypes = propTypes;


const mapStateToProps = (state) => {
  return {
    selectedMissingTicketNumberId: getSelectedMissingTicketNumberId(state),
  };
};


const mapDispatchToProps = {
  selectMissingTicketNumberId: selectMissingTicketNumberIdAction,
};


const withRedux = connect(mapStateToProps, mapDispatchToProps);


const withNoMissingTicketNumbers = branch(
  (props) => { return props.missingTicketNumbers.length === 0; },
  renderComponent((props) => {
    return (
      <div className="panel-body" style={{ textAlign: 'center' }}>
        <h4>Empty</h4>
        <p className="text-muted">No Missing ticket numbers found</p>
      </div>
    );
  }),
);


const withSelectFirstJob = lifecycle({
  componentWillMount() {
    const { missingTicketNumbers, selectMissingTicketNumberId } = this.props;
    if (missingTicketNumbers.length > 0) {
      selectMissingTicketNumberId(missingTicketNumbers[0].id);
    }
  },
});


const withHide = branch(
  (props) => { return props.selectedMissingTicketNumberId === null; },
  renderNothing,
);


const enhance = compose(
  allMissingTicketNumbers,
  withNoMissingTicketNumbers,
  withRedux,
  withSelectFirstJob,
  withHide,
);

export default enhance(MissingTicketNumbersList);
